import { DEFAULT_FETCHING_STATE, DEFAULT_NO_ERROR } from "state/constants";
import Types from "./types";

const INITIAL_STATE = {
    todayMood: null,
    moodHistory: [],
    journals: [],
    alerts: { sosAlerts: [], moodAlerts: [], total: 0 },
    patientSummary: null,
    fetching: {
        saveMood: { ...DEFAULT_FETCHING_STATE },
        moodHistory: { ...DEFAULT_FETCHING_STATE },
        saveJournal: { ...DEFAULT_FETCHING_STATE },
        fetchJournal: { ...DEFAULT_FETCHING_STATE },
        logSos: { ...DEFAULT_FETCHING_STATE },
        saveActivity: { ...DEFAULT_FETCHING_STATE },
        alerts: { ...DEFAULT_FETCHING_STATE },
        patientSummary: { ...DEFAULT_FETCHING_STATE },
    },
    error: { ...DEFAULT_NO_ERROR },
};

const reducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        // ─── MOOD ────────────────────────────────────────────
        case Types.SAVE_MOOD_START:
            return {
                ...state,
                fetching: { ...state.fetching, saveMood: { ...DEFAULT_FETCHING_STATE, state: true } },
            };
        case Types.SAVE_MOOD_SUCCESS:
            return {
                ...state,
                todayMood: action.payload,
                fetching: { ...state.fetching, saveMood: { ...DEFAULT_FETCHING_STATE } },
                error: { ...DEFAULT_NO_ERROR },
            };
        case Types.SAVE_MOOD_ERROR:
            return {
                ...state,
                fetching: { ...state.fetching, saveMood: { ...DEFAULT_FETCHING_STATE } },
                error: { timestamp: Date.now(), message: action.payload },
            };

        case Types.FETCH_MOOD_HISTORY_START:
            return {
                ...state,
                fetching: { ...state.fetching, moodHistory: { ...DEFAULT_FETCHING_STATE, state: true } },
            };
        case Types.FETCH_MOOD_HISTORY_SUCCESS:
            return {
                ...state,
                moodHistory: action.payload.history || [],
                todayMood: action.payload.today || state.todayMood,
                fetching: { ...state.fetching, moodHistory: { ...DEFAULT_FETCHING_STATE } },
                error: { ...DEFAULT_NO_ERROR },
            };
        case Types.FETCH_MOOD_HISTORY_ERROR:
            return {
                ...state,
                fetching: { ...state.fetching, moodHistory: { ...DEFAULT_FETCHING_STATE } },
                error: { timestamp: Date.now(), message: action.payload },
            };

        // ─── JOURNAL ─────────────────────────────────────────
        case Types.SAVE_JOURNAL_START:
            return {
                ...state,
                fetching: { ...state.fetching, saveJournal: { ...DEFAULT_FETCHING_STATE, state: true } },
            };
        case Types.SAVE_JOURNAL_SUCCESS:
            return {
                ...state,
                journals: [action.payload, ...state.journals],
                fetching: { ...state.fetching, saveJournal: { ...DEFAULT_FETCHING_STATE } },
                error: { ...DEFAULT_NO_ERROR },
            };
        case Types.SAVE_JOURNAL_ERROR:
            return {
                ...state,
                fetching: { ...state.fetching, saveJournal: { ...DEFAULT_FETCHING_STATE } },
                error: { timestamp: Date.now(), message: action.payload },
            };

        case Types.FETCH_JOURNAL_START:
            return {
                ...state,
                fetching: { ...state.fetching, fetchJournal: { ...DEFAULT_FETCHING_STATE, state: true } },
            };
        case Types.FETCH_JOURNAL_SUCCESS:
            return {
                ...state,
                journals: action.payload,
                fetching: { ...state.fetching, fetchJournal: { ...DEFAULT_FETCHING_STATE } },
                error: { ...DEFAULT_NO_ERROR },
            };
        case Types.FETCH_JOURNAL_ERROR:
            return {
                ...state,
                fetching: { ...state.fetching, fetchJournal: { ...DEFAULT_FETCHING_STATE } },
                error: { timestamp: Date.now(), message: action.payload },
            };

        // ─── SOS ─────────────────────────────────────────────
        case Types.LOG_SOS_START:
            return {
                ...state,
                fetching: { ...state.fetching, logSos: { ...DEFAULT_FETCHING_STATE, state: true } },
            };
        case Types.LOG_SOS_SUCCESS:
            return {
                ...state,
                fetching: { ...state.fetching, logSos: { ...DEFAULT_FETCHING_STATE } },
            };
        case Types.LOG_SOS_ERROR:
            return {
                ...state,
                fetching: { ...state.fetching, logSos: { ...DEFAULT_FETCHING_STATE } },
            };

        // ─── ACTIVITY ────────────────────────────────────────
        case Types.SAVE_ACTIVITY_START:
            return {
                ...state,
                fetching: { ...state.fetching, saveActivity: { ...DEFAULT_FETCHING_STATE, state: true } },
            };
        case Types.SAVE_ACTIVITY_SUCCESS:
            return {
                ...state,
                fetching: { ...state.fetching, saveActivity: { ...DEFAULT_FETCHING_STATE } },
            };
        case Types.SAVE_ACTIVITY_ERROR:
            return {
                ...state,
                fetching: { ...state.fetching, saveActivity: { ...DEFAULT_FETCHING_STATE } },
            };

        // ─── ALERTS (therapist) ──────────────────────────────
        case Types.FETCH_ALERTS_START:
            return {
                ...state,
                fetching: { ...state.fetching, alerts: { ...DEFAULT_FETCHING_STATE, state: true } },
            };
        case Types.FETCH_ALERTS_SUCCESS:
            return {
                ...state,
                alerts: action.payload,
                fetching: { ...state.fetching, alerts: { ...DEFAULT_FETCHING_STATE } },
            };
        case Types.FETCH_ALERTS_ERROR:
            return {
                ...state,
                fetching: { ...state.fetching, alerts: { ...DEFAULT_FETCHING_STATE } },
                error: { timestamp: Date.now(), message: action.payload },
            };

        // ─── PATIENT SUMMARY (therapist) ─────────────────────
        case Types.FETCH_PATIENT_SUMMARY_START:
            return {
                ...state,
                fetching: { ...state.fetching, patientSummary: { ...DEFAULT_FETCHING_STATE, state: true } },
            };
        case Types.FETCH_PATIENT_SUMMARY_SUCCESS:
            return {
                ...state,
                patientSummary: action.payload,
                fetching: { ...state.fetching, patientSummary: { ...DEFAULT_FETCHING_STATE } },
            };
        case Types.FETCH_PATIENT_SUMMARY_ERROR:
            return {
                ...state,
                fetching: { ...state.fetching, patientSummary: { ...DEFAULT_FETCHING_STATE } },
                error: { timestamp: Date.now(), message: action.payload },
            };

        case Types.RESET_ERROR:
            return { ...state, error: { ...DEFAULT_NO_ERROR } };

        default:
            return state;
    }
};

export default reducer;
